export const statusOptionsConfig = [
  { value: "undiagnosed", label: "Undiagnosed" },
  { value: "diagnosed", label: "Diagnosed (Clinically Significant)" },
  { value: "irrelevant", label: "Irrelevant / Artifact" },
];